import { getStock } from "@/common/mixins/analytics";

export const sendToGa4Dictionary = (
  action,
  actionParams,
  label,
  isFrisbuyAnalytic = false
) => {
  const actionPrefix = "frisbuy_";

  const GOOGLE_TAG = isFrisbuyAnalytic
    ? actionParams.settings.analytics.ga4.frisbuyTrackerId || undefined
    : actionParams.settings.analytics.ga4.clientTrackerId || undefined;

  if (!GOOGLE_TAG) {
    return;
  }

  switch (action) {
    // GALLERY
    case "Load":
      window.frisbuyGa4(
        "event",
        actionPrefix + "load",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          stock: getStock(
            actionParams.postList,
            actionParams.settings.embedId,
            actionParams.settings.skuId
          ),
        })
      );
      break;
    case "Eyesight":
      window.frisbuyGa4(
        "event",
        actionPrefix + "eyesight",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          stock: getStock(
            actionParams.postList,
            actionParams.settings.embedId,
            actionParams.settings.skuId
          ),
        })
      );
      break;
    case "Eyesight5Sec":
      window.frisbuyGa4(
        "event",
        actionPrefix + "eyesight5sec",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          stock: getStock(
            actionParams.postList,
            actionParams.settings.embedId,
            actionParams.settings.skuId
          ),
        })
      );
      break;
    case "ClickPic":
      window.frisbuyGa4(
        "event",
        actionPrefix + "clickpost",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          stock: getStock(
            actionParams.postList,
            actionParams.settings.embedId,
            actionParams.settings.skuId
          ),
          post_id: label.fbProduct,
          prov_post_id: label.provPostId,
        })
      );
      break;
    case "ViewPic":
      window.frisbuyGa4(
        "event",
        actionPrefix + "viewpost",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          stock: getStock(
            actionParams.postList,
            actionParams.settings.embedId,
            actionParams.settings.skuId
          ),
          post_id: label.fbProduct,
          prov_post_id: label.provPostId,
        })
      );
      break;
    case "ClickLink":
      window.frisbuyGa4(
        "event",
        actionPrefix + "clicklink",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          post_id: label.fbProduct,
          prov_post_id: label.provPostId,
          link_id: label.link,
          link_label: label.linklabel,
        })
      );
      break;
    case "FilterElastic":
      window.frisbuyGa4(
        "event",
        actionPrefix + "filterload",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          gallery_id: actionParams.settings.galleryId,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          gender:
            actionParams.settings.analytics.elasticFilter &&
            actionParams.settings.analytics.elasticFilter.gender
              ? actionParams.settings.analytics.elasticFilter.gender
              : null,
          color:
            actionParams.settings.analytics.elasticFilter &&
            actionParams.settings.analytics.elasticFilter.color
              ? actionParams.settings.analytics.elasticFilter.color
              : null,
          category_id:
            actionParams.settings.analytics.elasticFilter &&
            actionParams.settings.analytics.elasticFilter.categoryId
              ? actionParams.settings.analytics.elasticFilter.categoryId
              : null,
          stock: getStock(
            actionParams.postList,
            actionParams.settings.embedId,
            actionParams.settings.skuId
          ),
        })
      );
      break;
    case "NextPage":
      window.frisbuyGa4(
        "event",
        actionPrefix + "nextpage",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          stock: getStock(
            actionParams.postList,
            actionParams.settings.embedId,
            actionParams.settings.skuId
          ),
          page_number: label.pageNumber || label,
        })
      );
      break;
    case "PlayVideo":
      window.frisbuyGa4(
        "event",
        actionPrefix + "playvideo",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          post_id: label.fbProduct,
          prov_post_id: label.provPostId,
          stock: getStock(
            actionParams.postList,
            actionParams.settings.embedId,
            actionParams.settings.skuId
          ),
        })
      );
      break;
    case "Swipe":
      window.frisbuyGa4(
        "event",
        actionPrefix + "swipe",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          stock: getStock(
            actionParams.postList,
            actionParams.settings.embedId,
            actionParams.settings.skuId
          ),
        })
      );
      break;
    case "AddToCart":
      window.frisbuyGa4(
        "event",
        actionPrefix + "addtocart",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          gallery_id: actionParams.settings.galleryId,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          stock: getStock(
            actionParams.postList,
            actionParams.settings.embedId,
            actionParams.settings.skuId
          ),
          post_id: label.fbProduct,
          prov_post_id: label.provPostId,
        })
      );
      break;
    case "AddToFavorite":
      window.frisbuyGa4(
        "event",
        /*
          NOTE: standart google event name. Items prop doesn't work on custom event.
          It's not 'recomended' event. It's required to use `items`
          src: https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#purchase
        */
        "add_to_wishlist",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          gallery_id: actionParams.settings.galleryId,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          stock: getStock(
            actionParams.postList,
            actionParams.settings.embedId,
            actionParams.settings.skuId
          ),
          post_id: label.fbProduct,
          prov_post_id: label.provPostId,

          items: label.items.map((item) => {
            return {
              item_id: item.sku?.offerId,
              item_name: item.title,
              item_brand: item.sku?.brandName,
              price: item.sku?.price.replaceAll(/\s/gi, ""),
              currency: "RUB",
              quantity: 1,
            };
          }),
        })
      );
      break;
    case "RemoveFromFavorite":
      window.frisbuyGa4(
        "event",
        actionPrefix + "removefromfavorite",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          gallery_id: actionParams.settings.galleryId,
          embed_id: actionParams.settings.embedId,
          fr_uid: actionParams.settings.frisbuyUID,
          sku_id: actionParams.settings.skuId,
          skug_id: actionParams.settings.groupId,
          category_id: actionParams.settings.categoryId || null,
          stock: getStock(
            actionParams.postList,
            actionParams.settings.embedId,
            actionParams.settings.skuId
          ),
          post_id: label.fbProduct,
          prov_post_id: label.provPostId,
        })
      );
      break;

    // DUMMY
    case "frisbuy_showstubview":
      window.frisbuyGa4(
        "event",
        actionPrefix + "showstubview",
        deleteEmptyFields({
          send_to: GOOGLE_TAG,
          gallery_id: actionParams.settings.galleryId,
          embed_id: actionParams.settings.embedId,
          sku_id: actionParams.settings.skuId,
        })
      );
      break;

    default:
      console.log(`switch DEFAULT - action - ${action} - NOT match any case!`);
      break;
  }
};

const deleteEmptyFields = (object) => {
  for (const field in object) {
    if (
      !object[field] &&
      typeof object[field] !== "number" &&
      typeof object[field] !== "boolean"
    ) {
      delete object[field];
    }
  }

  return object;
};
